import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';
import type { TextFieldPropsWithEdit } from '@/types';

interface ManifestCheckReferenceFieldProps extends TextFieldPropsWithEdit {
  isEditing?: boolean;
}

export default function ManifestCheckReferenceField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  edit,
  isEditing = false,
}: ManifestCheckReferenceFieldProps): React.JSX.Element {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    setError(false);
  };

  const is_blank = value === '';
  const helper_text = 'Enter reference text of the governing document that this validates.';
  const warning_text = 'Specifying the reference text is recommended as it will improve the AI agent\'s suggestion for improvement when a document is non-compliant';

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          label='Reference'
          id='reference'
          aria-describedby='reference-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          disabled={edit}
          slotProps={{
            inputLabel: { shrink: value?.length > 0 },
          }}
        />
        {error ? (
          <FormHelperText id='reference-helper-text' error>
            {error}
          </FormHelperText>
        ) : (
          <>
            <FormHelperText id='reference-helper-text'>
              {helper_text}
            </FormHelperText>
            {is_blank && isEditing && (
              <FormHelperText id='reference-warning-text' sx={{ color: 'warning.main' }}>
                {warning_text}
              </FormHelperText>
            )}
          </>
        )}
      </FormControl>
    </Box>
  );
}

